document.documentElement.classList.add("pm-js");

window.addEventListener("load", () => {
  document.body.classList.add("is-loaded");
});

const header = document.querySelector("[data-pm-header]");
const editionButtons = document.querySelectorAll("[data-pm-edition]");
const editionImages = document.querySelectorAll("[data-pm-edition-image]");
const editionDescription = document.querySelector("[data-pm-edition-description]");
const editionIndex = document.querySelector("[data-pm-edition-index]");
const editionShop = document.querySelector("[data-pm-edition-shop]");
const editionShopLabel = document.querySelector("[data-pm-edition-shop-label]");
const floatingMark = document.querySelector("[data-pm-floating-mark]");
const productRails = document.querySelectorAll("[data-pm-product-rail]");

function updateHeader() {
  if (!header) return;
  header.classList.toggle("is-scrolled", window.scrollY > 24);
}

editionButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const selectedEdition = button.dataset.pmEdition;

    editionButtons.forEach((candidate) => {
      const isSelected = candidate === button;
      candidate.classList.toggle("is-active", isSelected);
      candidate.setAttribute("aria-pressed", String(isSelected));
    });

    editionImages.forEach((image) => {
      image.classList.toggle(
        "is-active",
        image.dataset.pmEditionImage === selectedEdition,
      );
    });

    if (editionDescription) {
      editionDescription.textContent = button.dataset.description;
    }

    if (editionIndex) {
      editionIndex.textContent = button.dataset.index;
    }

    if (editionShop) {
      const shopUrl = button.dataset.shopUrl;
      editionShop.hidden = !shopUrl;
      if (shopUrl) {
        editionShop.href = shopUrl;
        if (editionShopLabel) {
          editionShopLabel.textContent = button.dataset.shopLabel;
        }
      } else {
        editionShop.removeAttribute("href");
      }
    }
  });
});

productRails.forEach((rail) => {
  const track = rail.querySelector("[data-pm-product-track]");
  const cards = Array.from(rail.querySelectorAll("[data-pm-product-card]"));
  const currentIndex = rail.querySelector("[data-pm-product-index]");

  if (!track || !currentIndex || cards.length < 2) return;

  let railFrame;

  function warmProductImages() {
    rail.querySelectorAll('img[loading="lazy"]').forEach((image) => {
      image.loading = "eager";
    });
  }

  function updateProductIndex() {
    const trackLeft = track.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card, index) => {
      const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);

      if (distance < closestDistance) {
        closestIndex = index;
        closestDistance = distance;
      }
    });

    currentIndex.textContent = String(closestIndex + 1).padStart(2, "0");
    railFrame = null;
  }

  track.addEventListener(
    "scroll",
    () => {
      if (railFrame) return;
      railFrame = window.requestAnimationFrame(updateProductIndex);
    },
    { passive: true },
  );

  window.addEventListener("resize", updateProductIndex, { passive: true });
  updateProductIndex();

  if ("IntersectionObserver" in window) {
    const imageObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        warmProductImages();
        imageObserver.disconnect();
      },
      { rootMargin: "800px 0px" },
    );

    imageObserver.observe(rail);
  } else {
    warmProductImages();
  }
});

if ("IntersectionObserver" in window) {
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.14 },
  );

  document.querySelectorAll(".pm-reveal").forEach((element) => {
    revealObserver.observe(element);
  });
} else {
  document.querySelectorAll(".pm-reveal").forEach((element) => {
    element.classList.add("is-visible");
  });
}

let scrollFrame;
window.addEventListener(
  "scroll",
  () => {
    updateHeader();
    if (scrollFrame) return;

    scrollFrame = window.requestAnimationFrame(() => {
      if (floatingMark) {
        const section = floatingMark.closest(".pm-story");
        const bounds = section.getBoundingClientRect();
        const progress =
          (window.innerHeight - bounds.top) /
          (window.innerHeight + bounds.height);
        const drift = Math.max(-24, Math.min(24, (progress - 0.5) * 48));

        floatingMark.style.transform =
          `translate(-50%, calc(-50% + ${drift}px))`;
      }

      scrollFrame = null;
    });
  },
  { passive: true },
);

updateHeader();
